/* src/app/pos/components/custom-price-dialog/custom-price-dialog.component.css */
/*# sourceMappingURL=custom-price-dialog.component.css.map */
